<template>
  <div class="l-container AppointmentsAdd">

    <p class="m-label">
      新規追加
      <span class="errors">
        <span v-if="!valid"> {{errors}} が入力されていません</span>
        <span v-if="valid"></span>
      </span>
    </p>

    <btn @click.native="reset">Reset</btn>

    <form class="h-adr" @submit.prevent="postAppointment">
      <div class="form-wrapper">
        <appointment-form :appointment="appointment" :watch="watch"></appointment-form>
      </div>

      <button type="submit" class="u-btn"><i class="fa fa-user-plus"></i>AP情報を新規追加</button>
    </form>

  </div>
</template>

<script>
import moment from 'moment'
export default {
  data () {
    return {
      appointment: {
        family_id: '',
        state: 0,
        f_name: '',
        l_name: '',
        f_name_kana: '',
        l_name_kana: '',
        zip: '',
        pref: 0,
        geometry: '',
        address1: '',
        address2: '',
        tel1: '',
        tel2: '',
        fax: '',
        mail: '',
        contact_date: moment().format('YYYY/MM/DD'),
        support: 0,
        missing_detail: 0,
        contact_later: 0,
        next_contact_date: '0001/01/01',
        next_contact_method: 0,
        result: 0,
        acquisition_date: '',
        ap_type: 0,
        hp_type: 0,
        gender: 0,
        school_type: 0,
        school_stage: 0,
        school_name: '',
        grade: 0,
        memo: '',
        dm: '',
        dm_information: 0,
        shop_type: 0,
        shop_name: '',
        contact_method: '',
        hp_browse: 0,
        visit_date: '',
        person: '',
        note: '',
        visit_time: '',
        request_of_day_of_week: '',
        request_of_day_of_week_note: '',
        sending_date: '',
        sending_time: '',
        contact_person: 0,
        parking: 0,
        parking_note: '',
        sub_f_name: '',
        sub_l_name: '',
        sub_f_name_kana: '',
        sub_l_name_kana: '',
        sub_grade: 0,
        sub_school_type: 0,
        sub_school_stage: 0,
        sub_school_name: '',
        sub_gender: 0,
        achievement: '',
        learning: '',
        learning_start_period: '',
        learning_nervous: '',
        learning_result: 0,
        learning_continuation: 0,
        sub_achievement: '',
        sub_learning: '',
        sub_learning_start_period: '',
        sub_learning_nervous: '',
        sub_learning_result: 0,
        sub_learning_continuation: 0,
        fathers_involvement: 0,
        sending_method: 0,
        confirm_check: 0,
        preferred_contact: 0,
        contact_timezone: '',
        transmission_item_company: 0,
        transmission_item_course: 0,
        transmission_item_visitor: 0,
        transmission_item_purpose: 0,
        transmission_item_requiredtime: 0,

        sending_productsArray: [],
        attendedArray: [],
        noticesArray: [],
        mediumArray: []
      },

      watch: {
        state: '',
        pref: '',
        support: '',
        missing_detail: '',
        contact_later: '',
        result: '',
        ap_type: '',
        hp_type: '',
        school_stage: '',
        grade: '',
        dm_information: '',
        next_contact_method: '',
        shop_type: '',
        hp_browse: '',
        contact_person: '',
        sub_grade: '',
        sub_school_stage: '',
        learning_result: '',
        sub_learning_result: '',
        learning_continuation: '',
        sub_learning_continuation: '',
        sending_method: '',
        confirm_check: '',
        preferred_contact: '',
        transmission_item_company: '',
        transmission_item_course: '',
        transmission_item_visitor: '',
        transmission_item_purpose: '',
        transmission_item_requiredtime: ''
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },

    sending_products () {
      let sending_products = this.appointment.sending_productsArray.join()
      return sending_products
    },

    attended () {
      let attended = this.appointment.attendedArray.join()
      return attended
    },

    notices () {
      let notices = this.appointment.noticesArray.join()
      return notices
    },

    // validation
    address1Errors () {
      return this.appointment.address1 ? [] : ['住所(市区町村・番地)']
    },

    contact_dateErrors () {
      return this.appointment.contact_date ? [] : ['問い合わせ日']
    },

    acquisition_dateErrors () {
      return this.appointment.acquisition_date ? [] : ['取得日']
    },

    supportErrors () {
      return this.appointment.support ? [] : ['AP結果']
    },

    contact_methodErrors () {
      return this.appointment.contact_method ? [] : ['AP連絡方法']
    },

    visit_dateErrors () {
      return this.appointment.visit_date ? [] : ['訪問日']
    },

    sending_dateErrors () {
      return this.appointment.sending_date ? [] : ['郵送・FAX / 予定日']
    },

    errors: function () {
      let errors = [].concat(
        this.address1Errors,
        this.contact_dateErrors,
        this.acquisition_dateErrors,
        this.supportErrors,
        this.contact_methodErrors,
        this.visit_dateErrors,
        this.sending_dateErrors
      )
      let errorsJoin = errors.join('・')
      return errorsJoin
    },
    valid: function () {
      return !this.errors
    }
  },
  watch: {
    'watch.state': function (now, old) {
      if (now) {
        this.appointment.state = now.value
      }
    },

    'watch.pref': function (now, old) {
      if (now) {
        this.appointment.pref = now.id
        this.appointment.geometry = now.name
      }
    },

    'watch.support': function (now, old) {
      if (now) {
        this.appointment.support = now.value
      }
    },

    'watch.missing_detail': function (now, old) {
      // console.log(now.length)
      // let array = []
      // for (let i = 0; i < now.length; i++) {
      //   console.log(now[i].value)
      //   array.push(now[i].value)
      // }
      // console.log(array)
      // this.appointment.missing_detail = array.join()
      if (now) {
        this.appointment.missing_detail = now.value
      }
    },

    'watch.contact_later': function (now, old) {
      if (now) {
        this.appointment.contact_later = now.value
      }
    },

    'watch.result': function (now, old) {
      if (now) {
        this.appointment.result = now.value
      }
    },

    'watch.ap_type': function (now, old) {
      if (now) {
        this.appointment.ap_type = now.value
      }
    },

    'watch.hp_type': function (now, old) {
      if (now) {
        this.appointment.hp_type = now.value
      }
    },

    'watch.school_stage': function (now, old) {
      if (now) {
        this.appointment.school_stage = now.value
      }
    },

    'watch.grade': function (now, old) {
      if (now) {
        this.appointment.grade = now.value
      }
    },

    'watch.dm_information': function (now, old) {
      if (now) {
        this.appointment.dm_information = now.value
      }
    },

    'watch.next_contact_method': function (now, old) {
      if (now) {
        this.appointment.next_contact_method = now.value
      }
    },

    'watch.shop_type': function (now, old) {
      if (now) {
        this.appointment.shop_type = now.value
      }
    },

    'watch.hp_browse': function (now, old) {
      if (now) {
        this.appointment.hp_browse = now.value
      }
    },

    'watch.contact_person': function (now, old) {
      if (now) {
        this.appointment.contact_person = now.value
      }
    },

    'watch.sub_grade': function (now, old) {
      if (now) {
        this.appointment.sub_grade = now.value
      }
    },

    'watch.sub_school_stage': function (now, old) {
      if (now) {
        this.appointment.sub_school_stage = now.value
      }
    },

    'watch.learning_result': function (now, old) {
      if (now) {
        this.appointment.learning_result = now.value
      }
    },

    'watch.learning_continuation': function (now, old) {
      if (now) {
        this.appointment.learning_continuation = now.value
      }
    },

    'watch.sub_learning_result': function (now, old) {
      if (now) {
        this.appointment.sub_learning_result = now.value
      }
    },

    'watch.sub_learning_continuation': function (now, old) {
      if (now) {
        this.appointment.sub_learning_continuation = now.value
      }
    },

    'watch.sending_method': function (now, old) {
      if (now) {
        this.appointment.sending_method = now.value
      }
    },

    'watch.confirm_check': function (now, old) {
      if (now) {
        this.appointment.confirm_check = now.value
      }
    },

    'watch.preferred_contact': function (now, old) {
      if (now) {
        this.appointment.preferred_contact = now.value
      }
    },

    'watch.transmission_item_company': function (now, old) {
      if (now === true) {
        this.appointment.transmission_item_company = 1
      } else if (now === false) {
        this.appointment.transmission_item_company = 0
      }
    },

    'watch.transmission_item_course': function (now, old) {
      if (now === true) {
        this.appointment.transmission_item_course = 1
      } else if (now === false) {
        this.appointment.transmission_item_course = 0
      }
    },

    'watch.transmission_item_visitor': function (now, old) {
      if (now === true) {
        this.appointment.transmission_item_visitor = 1
      } else if (now === false) {
        this.appointment.transmission_item_visitor = 0
      }
    },

    'watch.transmission_item_purpose': function (now, old) {
      if (now === true) {
        this.appointment.transmission_item_purpose = 1
      } else if (now === false) {
        this.appointment.transmission_item_purpose = 0
      }
    },

    'watch.transmission_item_requiredtime': function (now, old) {
      if (now === true) {
        this.appointment.transmission_item_requiredtime = 1
      } else if (now === false) {
        this.appointment.transmission_item_requiredtime = 0
      }
    }
  },
  methods: {
    postAppointment () {
      if (this.appointment.mediumArray.length === 0) {
        // console.log(this.appointment.mediumArray.length)
        alert('媒体が選択されていません')
      } else {
        this.$store.dispatch('postAppointment', {
          this: this,
          appointment: this.appointment,
          sending_products: this.sending_products,
          attended: this.attended,
          notices: this.notices,
          watch: this.watch,
          reset: this.reset
        })
        this.save()
      }
    },
    save () {
      // alert('save')
      let arr = []
      let obj = {

        state: this.watch.state,
        f_name: this.appointment.f_name,
        l_name: this.appointment.l_name,
        f_name_kana: this.appointment.f_name_kana,
        l_name_kana: this.appointment.l_name_kana,
        zip: this.appointment.zip,
        pref: this.watch.pref,
        address1: this.appointment.address1,
        address2: this.appointment.address2,
        tel1: this.appointment.tel1,
        tel2: this.appointment.tel2,
        fax: this.appointment.fax,
        mail: this.appointment.mail,
        contact_date: this.appointment.contact_date,
        support: this.watch.support,
        missing_detail: this.watch.missing_detail,
        contact_later: this.watch.contact_later,
        next_contact_date: this.appointment.next_contact_date,
        next_contact_method: this.appointment.next_contact_method,
        result: this.watch.result,
        acquisition_date: this.appointment.acquisition_date,
        ap_type: this.watch.ap_type,
        mediumArray: this.appointment.mediumArray,
        hp_type: this.watch.hp_type,
        gender: this.appointment.gender,
        school_type: this.appointment.school_type,
        school_stage: this.watch.school_stage,
        school_name: this.appointment.school_name,
        grade: this.watch.grade,
        memo: this.appointment.memo,
        dm: this.appointment.dm,
        dm_information: this.watch.dm_information,
        shop_type: this.watch.shop_type,
        shop_name: this.appointment.shop_name,
        contact_method: this.appointment.contact_method,
        hp_browse: this.watch.hp_browse,
        person: this.appointment.person,
        note: this.appointment.note,
        visit_date: this.appointment.visit_date,
        visit_time: this.appointment.visit_time,
        request_of_day_of_week: this.appointment.request_of_day_of_week,
        request_of_day_of_week_note: this.appointment.request_of_day_of_week_note,
        sending_date: this.appointment.sending_date,
        sending_time: this.appointment.sending_time,
        contact_person: this.watch.contact_person,
        parking: this.appointment.parking,
        parking_note: this.appointment.parking_note,
        sub_f_name: this.appointment.sub_f_name,
        sub_l_name: this.appointment.sub_l_name,
        sub_f_name_kana: this.appointment.sub_f_name_kana,
        sub_l_name_kana: this.appointment.sub_l_name_kana,
        sub_grade: this.watch.sub_grade,
        sub_school_type: this.appointment.sub_school_type,
        sub_school_stage: this.watch.sub_school_stage,
        sub_school_name: this.appointment.sub_school_name,
        sub_gender: this.appointment.sub_gender,
        achievement: this.appointment.achievement,
        learning: this.appointment.learning,
        learning_start_period: this.appointment.learning_start_period,
        learning_nervous: this.appointment.learning_nervous,
        learning_result: this.watch.learning_result,
        learning_continuation: this.watch.learning_continuation,
        sub_achievement: this.appointment.sub_achievement,
        sub_learning: this.appointment.sub_learning,
        sub_learning_start_period: this.appointment.sub_learning_start_period,
        sub_learning_nervous: this.appointment.sub_learning_nervous,
        sub_learning_result: this.watch.sub_learning_result,
        sub_learning_continuation: this.watch.sub_learning_continuation,
        attendedArray: this.appointment.attendedArray,
        fathers_involvement: this.appointment.fathers_involvement,
        noticesArray: this.appointment.noticesArray,
        sending_productsArray: this.appointment.sending_productsArray,
        sending_method: this.watch.sending_method,
        preferred_contact: this.watch.preferred_contact,
        contact_timezone: this.appointment.contact_timezone,
        transmission_item_company: this.appointment.transmission_item_company,
        transmission_item_course: this.appointment.transmission_item_course,
        transmission_item_visitor: this.appointment.transmission_item_visitor,
        transmission_item_purpose: this.appointment.transmission_item_purpose,
        transmission_item_requiredtime: this.appointment.transmission_item_requiredtime
      }
      arr.push(obj)
      let setjson = JSON.stringify(obj)
      localStorage.setItem('AppointmentsAdd', setjson)
    },
    get () {
      // alert('get')
      let getjson = localStorage.getItem('AppointmentsAdd')
      let obj = JSON.parse(getjson)

      this.watch.state = obj['state']
      this.appointment.f_name = obj['f_name']
      this.appointment.l_name = obj['l_name']
      this.appointment.f_name_kana = obj['f_name_kana']
      this.appointment.l_name_kana = obj['l_name_kana']
      this.appointment.zip = obj['zip']
      this.watch.pref = obj['pref']
      this.appointment.address1 = obj['address1']
      this.appointment.address2 = obj['address2']
      this.appointment.tel1 = obj['tel1']
      this.appointment.tel2 = obj['tel2']
      this.appointment.fax = obj['fax']
      this.appointment.mail = obj['mail']
      this.appointment.contact_date = obj['contact_date']
      this.watch.support = obj['support']
      this.watch.missing_detail = obj['missing_detail']
      this.watch.contact_later = obj['contact_later']
      this.appointment.next_contact_date = obj['next_contact_date']
      this.watch.next_contact_method = obj['next_contact_method']
      this.watch.result = obj['result']
      this.appointment.acquisition_date = obj['acquisition_date']
      this.watch.ap_type = obj['ap_type']
      this.appointment.mediumArray = obj['mediumArray']
      this.watch.hp_type = obj['hp_type']
      this.appointment.gender = obj['gender']
      this.appointment.school_type = obj['school_type']
      this.watch.school_stage = obj['school_stage']
      this.appointment.school_name = obj['school_name']
      this.watch.grade = obj['grade']
      this.appointment.memo = obj['memo']
      this.appointment.dm = obj['dm']
      this.watch.dm_information = obj['dm_information']
      this.watch.shop_type = obj['shop_type']
      this.appointment.shop_name = obj['shop_name']
      this.appointment.contact_method = obj['contact_method']
      this.watch.hp_browse = obj['hp_browse']
      this.appointment.person = obj['person']
      this.appointment.note = obj['note']
      this.appointment.visit_date = obj['visit_date']
      this.appointment.visit_time = obj['visit_time']
      this.appointment.request_of_day_of_week = obj['request_of_day_of_week']
      this.appointment.request_of_day_of_week_note = obj['request_of_day_of_week_note']
      this.appointment.sending_date = obj['sending_date']
      this.appointment.sending_time = obj['sending_time']
      this.watch.contact_person = obj['contact_person']
      this.appointment.parking = obj['parking']
      this.appointment.parking_note = obj['parking_note']
      this.appointment.sub_f_name = obj['sub_f_name']
      this.appointment.sub_l_name = obj['sub_l_name']
      this.appointment.sub_f_name_kana = obj['sub_f_name_kana']
      this.appointment.sub_l_name_kana = obj['sub_l_name_kana']
      this.watch.sub_grade = obj['sub_grade']
      this.appointment.sub_school_type = obj['sub_school_type']
      this.watch.sub_school_stage = obj['sub_school_stage']
      this.appointment.sub_school_name = obj['sub_school_name']
      this.appointment.sub_gender = obj['sub_gender']
      this.appointment.achievement = obj['achievement']
      this.appointment.learning = obj['learning']
      this.appointment.learning_start_period = obj['learning_start_period']
      this.appointment.learning_nervous = obj['learning_nervous']
      this.watch.learning_result = obj['learning_result']
      this.watch.learning_continuation = obj['learning_continuation']
      this.appointment.sub_achievement = obj['sub_achievement']
      this.appointment.sub_learning = obj['sub_learning']
      this.appointment.sub_learning_start_period = obj['sub_learning_start_period']
      this.appointment.sub_learning_nervous = obj['sub_learning_nervous']
      this.watch.sub_learning_result = obj['sub_learning_result']
      this.watch.sub_learning_continuation = obj['sub_learning_continuation']
      this.appointment.attendedArray = obj['attendedArray']
      this.appointment.fathers_involvement = obj['fathers_involvement']
      this.appointment.noticesArray = obj['noticesArray']
      this.appointment.sending_productsArray = obj['sending_productsArray']
      this.watch.sending_method = obj['sending_method']
      this.watch.preferred_contact = obj['preferred_contact']
      this.appointment.contact_timezone = obj['contact_timezone']
      this.appointment.transmission_item_company = obj['transmission_item_company']
      this.appointment.transmission_item_course = obj['transmission_item_course']
      this.appointment.transmission_item_visitor = obj['transmission_item_visitor']
      this.appointment.transmission_item_purpose = obj['transmission_item_purpose']
      this.appointment.transmission_item_requiredtime = obj['transmission_item_requiredtime']
      // console.log(obj)
    },

    reset () {
      this.watch.state = 0
      this.appointment.f_name = ''
      this.appointment.l_name = ''
      this.appointment.f_name_kana = ''
      this.appointment.l_name_kana = ''
      this.appointment.zip = ''
      this.watch.pref = 0
      this.appointment.address1 = ''
      this.appointment.address2 = ''
      this.appointment.tel1 = ''
      this.appointment.tel2 = ''
      this.appointment.fax = ''
      this.appointment.mail = ''
      this.appointment.contact_date = moment().format('YYYY/MM/DD')
      this.watch.support = 0
      this.watch.missing_detail = 0
      this.watch.contact_later = 0
      this.appointment.next_contact_date = '0001/01/01'
      this.watch.next_contact_method = 0
      this.watch.result = 0
      this.appointment.acquisition_date = ''
      this.watch.ap_type = 0
      this.appointment.mediumArray = []
      this.watch.hp_type = 0

      this.appointment.gender = 0
      this.appointment.school_type = 0
      this.watch.school_stage = 0
      this.appointment.school_name = ''
      this.watch.grade = 0
      this.appointment.memo = ''
      this.appointment.dm = ''
      this.watch.dm_information = 0
      this.watch.shop_type = 0
      this.appointment.shop_name = ''
      this.appointment.contact_method = ''
      this.watch.hp_browse = 0
      this.appointment.person = ''
      this.appointment.note = ''
      this.appointment.visit_date = ''
      this.appointment.visit_time = ''
      this.appointment.request_of_day_of_week = ''
      this.appointment.request_of_day_of_week_note = ''
      this.appointment.sending_date = ''
      this.appointment.sending_time = ''
      this.watch.contact_person = 0
      this.appointment.parking = 0
      this.appointment.parking_note = ''
      this.appointment.sub_f_name = ''
      this.appointment.sub_l_name = ''
      this.appointment.sub_f_name_kana = ''
      this.appointment.sub_l_name_kana = ''
      this.watch.sub_grade = 0
      this.appointment.sub_school_type = 0
      this.watch.sub_school_stage = 0
      this.appointment.sub_school_name = ''
      this.appointment.sub_gender = 0
      this.appointment.achievement = ''
      this.appointment.learning = ''
      this.appointment.learning_start_period = ''
      this.appointment.learning_nervous = ''
      this.watch.learning_result = 0
      this.watch.learning_continuation = 0
      this.appointment.sub_achievement = ''
      this.appointment.sub_learning = ''
      this.appointment.sub_learning_start_period = ''
      this.appointment.sub_learning_nervous = ''
      this.watch.sub_learning_result = 0
      this.watch.sub_learning_continuation = 0
      this.appointment.attendedArray = []
      this.appointment.fathers_involvement = 0
      this.appointment.noticesArray = []
      this.appointment.sending_productsArray = []
      this.watch.sending_method = 0
      this.watch.preferred_contact = 0
      this.appointment.contact_timezone = ''
      this.appointment.transmission_item_company = 0
      this.appointment.transmission_item_course = 0
      this.appointment.transmission_item_visitor = 0
      this.appointment.transmission_item_purpose = 0
      this.appointment.transmission_item_requiredtime = 0
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.get()
    })
  },
  beforeRouteLeave (to, from, next) {
    this.save()
    next()
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.form-wrapper {
  overflow: scroll;
  height: calc(100vh - 260px);
}
.errors {
  color: red;
}
.fa-user-plus {
  margin-right: 5px;
}
.u-btn {
  margin-top: 1rem;
}
button {
  background-color: var(--color-point);
  color: #fff;
  margin-bottom: 13px;
  font-size:1rem;
  font-weight: bold;
  width: 100%;
  text-align: center;
  padding: 1em;
  border: 0;
  cursor: pointer;
  transition: opacity 0.5s ease-in-out;
  &:hover {
    opacity: .8;
  }
  &:focus {
    outline: 0;
  }
}
</style>



// WEBPACK FOOTER //
// AppointmentsAdd.vue?0d4dc0d8